import { render, staticRenderFns } from "./HistoryAttendance.vue?vue&type=template&id=012553bc&scoped=true&"
import script from "./HistoryAttendance.vue?vue&type=script&lang=js&"
export * from "./HistoryAttendance.vue?vue&type=script&lang=js&"
import style0 from "./HistoryAttendance.vue?vue&type=style&index=0&id=012553bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012553bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCol,VIcon})
